import TextBox from "../../../../../../common/components/molecule/TextBox/TextBox"
import styles from "./PowerInfoView.module.scss";
export interface PowerInfoViewProps  {
    inverter?: string | number | null
    batteryCapacity?: string | number | null

    powerGenerator?: string | number | null
    power?: string | number | null
}


export default function PowerInfoView({ inverter, batteryCapacity, power, powerGenerator}: PowerInfoViewProps) {
  return (
    <div className={styles['container']}>

    <div className={[styles['container__item'], styles['container__item--inverter']].join(" ")}>
      <TextBox content = {
        [
          {
            title: 'Onduleur PV',
            text: ''+inverter,
            unit: 'kWc'

          }
        ]
      } color="primary"/>


    </div>
    <div className={[styles['container__item'], styles['container__item--power']].join(" ")}>
      <TextBox content = {
        [
          {
            title: 'Puissance',
            text: ''+power,
            unit: 'kVA'

          }
        ]
      } />


    </div>

    <div className={[styles['container__item'], styles['container__item--inverter']].join(" ")}>
      <TextBox content = {
        [
          {
            title: 'Capacité de la batterie',
            text: ''+batteryCapacity,
            unit: 'kWh'
          }
        ]
      }/>


    </div>
    <div className={[styles['container__item'], styles['container__item--inverter']].join(" ")}>
      <TextBox content = {
        [
          {
            title: 'Groupe électrogène',
            text: ''+powerGenerator,
            unit: 'kVA'
          }
        ]
      }/>


    </div>
    </div>
  )
}
